module.exports = __webpack_public_path__ + "img/twitch.10021541.svg";